import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const updateRepairApi = async data => {
    const callResponse = await axios({
        url: endpoints.repairUpdatestatus,
        method: "patch",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => err.response.data);

    return callResponse;
};

export const fetchRepairAndReplaceListApi = async params => {
    const callResponse = await axios({
      url: endpoints.fetchQueryListApi,
      method: "GET",
      headers: getHeaders(),
      params,
    })
      .then(response => response.data)
      .catch(err => err.response.data);
  
    return callResponse;
  };

export const FetchRepairDataBoxIdApi = async params => {
    const callResponse = await axios({
        url: endpoints.fetchrepairDataBoxId,
        method: "GET",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => err.response.data);

    return callResponse;
};

export const FetchRepairDataCountApi = async params => {
    const callResponse = await axios({
        url: endpoints.QueryCount,
        method: "GET",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => err.response.data);

    return callResponse;
};



